<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Create sub-location</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="submitSubLocation">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="subLocationData.code" ref="codeInput" required
                   placeholder="Short sub-location code"/>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="subLocationData.name" required
                   placeholder="Full sub-location name"/>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="isSubmitButtonDisabled" @click="submitSubLocation">Create sub-location</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateSubLocationModal',
  props: {
    locationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      subLocationData: {
        code: '',
        name: '',
        location_id: this.locationId,
      },
    };
  },
  computed: {
    isSubmitButtonDisabled() {
      return this.subLocationData.code === '' || this.subLocationData.name === '';
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
  },
  methods: {
    submitSubLocation() {
      this.$emit('create-sub-location', this.subLocationData);
      this.$emit('close');
    },
    handleEnterKey() {
      if (!this.isCreateButtonDisabled) {
        this.submitSubLocation();
      }
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>